import { Context, Controller } from '@hotwired/stimulus';

export default class SafetyAlertController extends Controller {
  static targets = ['selectedSitesCount', 'selectableSite'];

  declare hasSelectedSitesCountTarget: boolean;

  declare selectedSitesCountTarget: HTMLElement;
  declare selectableSiteTargets: readonly HTMLInputElement[];

  constructor(context: Context) {
    super(context);

    this.onUpdateCount = this.onUpdateCount.bind(this);
  }

  public connect(): void {
    super.connect();

    this.onUpdateCount();
  }

  public selectableSiteTargetConnected(target: HTMLElement) {
    target.addEventListener('input', this.onUpdateCount);
  }

  public selectableSiteTargetDisconnected(target: HTMLElement) {
    target.removeEventListener('input', this.onUpdateCount);
  }

  public onUpdateCount() {
    let count = 0;

    this.selectableSiteTargets.forEach((input) => {
      if (input.checked) {
        count += 1;
      }
    });

    if (this.hasSelectedSitesCountTarget) {
      this.selectedSitesCountTarget.textContent = String(count);
    } else {
      document.querySelector(
        '[data-safety-alert-target="selectedSitesCount"]',
      )!.textContent = String(count);
    }
  }
}
